import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// pageCode跟埋点清单里的"页面编号"对应，每个页面固定一个，不要中途改动，
// 不然历史数据和新数据对不上号
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    meta: { title: "护理科研门诊", tab: "home", pageCode: "NRCU001" },
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/expert/list",
    name: "ExpertList",
    meta: { title: "全部专家", pageCode: "NRCU002" },
    component: () => import("@/views/ExpertList.vue"),
  },
  {
    path: "/direction/list",
    name: "DirectionList",
    meta: { title: "全部门诊方向", pageCode: "NRCU003" },
    component: () => import("@/views/DirectionList.vue"),
  },
  {
    path: "/direction/:id",
    name: "DirectionDetail",
    meta: { title: "门诊方向", pageCode: "NRCU004" },
    component: () => import("@/views/DirectionDetail.vue"),
  },
  {
    path: "/expert/:id",
    name: "ExpertDetail",
    meta: { title: "专家详情", pageCode: "NRCU005" },
    component: () => import("@/views/ExpertDetail.vue"),
  },
  {
    path: "/order/create",
    name: "OrderCreate",
    meta: { title: "填写咨询信息", needLogin: true, pageCode: "NRCU006" },
    component: () => import("@/views/OrderCreate.vue"),
  },
  {
    path: "/order/list",
    name: "MyOrders",
    meta: { title: "我的订单", needLogin: true, pageCode: "NRCU007" },
    component: () => import("@/views/MyOrders.vue"),
  },
  {
    path: "/order/:id/consult",
    name: "OrderConsult",
    meta: { title: "填写预咨询信息", needLogin: true, pageCode: "NRCU011" },
    component: () => import("@/views/OrderConsult.vue"),
  },
  {
    path: "/order/:id",
    name: "OrderDetail",
    meta: { title: "订单详情", needLogin: true, pageCode: "NRCU008" },
    component: () => import("@/views/OrderDetail.vue"),
  },
  {
    path: "/my",
    name: "My",
    meta: { title: "我的", tab: "my", pageCode: "NRCU009" },
    component: () => import("@/views/My.vue"),
  },
  {
    path: "/referral/list",
    name: "MyReferrals",
    meta: { title: "我的推荐", needLogin: true, pageCode: "NRCU012" },
    component: () => import("@/views/MyReferrals.vue"),
  },
];

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  if (to.meta.needLogin) {
    // 需要延迟引入，避免router/index.js和requireLogin.js循环依赖
    const { isLogin } = require("@/utils/common.js");
    if (!isLogin()) {
      const bus = require("@/utils/eventBus.js").default;
      // 注意：这里不能再调用 next(to.fullPath)，同一次导航里 next() 只能调用一次，
      // 下面已经调用过 next("/home") 了。登录成功后要跳回原页面，
      // 得用 router.push 这种随时能调用、不受"只能调一次"限制的方式。
      bus.$emit("show-login", { onSuccess: () => router.push(to.fullPath).catch(() => {}) });
      next("/home");
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  window.document.title = to.meta.title || "护理科研门诊";
  // 每次进入一个新页面，自动记一条"打开页面"，页面级别的到达率不用每个页面自己写代码
  if (to.meta.pageCode) {
    const { dataGather } = require("@/utils/logTracking.js");
    dataGather(to.meta.pageCode, `${to.meta.pageCode}-001`, { path: to.fullPath });
  }
});

export default router;
